import React, { useState, useEffect, useRef } from "react"
import Barcode from "../components/BarCode"
import { Button } from "semantic-ui-react"
import ReactToPrint from "react-to-print"
import { DataMatrixGeneratorComponent } from "@syncfusion/ej2-react-barcode-generator"
import ECPSignatureComponent from "../components/ECPSignatureComponentOld"

const TestingPage = () => {
  let componentRef = useRef()
  return (
    <>
      <div style={{ display: "none" }}>
        <DataMatrixGeneratorComponent
          id="barcode"
          width={"200px"}
          height={"150px"}
          ref={(el) => (componentRef = el)}
          value="Syncfusion"
        ></DataMatrixGeneratorComponent>
        <ReactToPrint
          trigger={() => (
            <Button circular icon="print" color="green" style={{ margin: 0 }} />
          )}
          content={() => componentRef}
        />
      </div>
      <div>
        <ECPSignatureComponent />
      </div>
    </>
  )
}

export default TestingPage
